// Machine-readable auth failure codes the backend sends in a 401 body's
// `code` field. Lets callers distinguish a genuinely expired token from
// any other auth failure (bad signature, malformed token, a transient
// JWKS-fetch hiccup) that looks identical over the wire but isn't
// actually a dead session.
export const AUTH_CODE_TOKEN_EXPIRED = 'TOKEN_EXPIRED'

export function getAuthErrorCode(error) {
    if (error && typeof error === 'object' && 'response' in error) {
        const data = error.response?.data
        return data?.code
    }
    return undefined
}
